import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {GoToTop} from 'components';
import Footer from 'containers/Footer';
import {ROUTES} from 'constants/routes';
import {SFC} from 'types/generic';

import * as S from './Styles';

/**
 * 全站布局（v3 改版后）：
 * - TopNav 为 fixed 玻璃导航，不占文档流；非首页内容区用 .v3-page-offset 补顶距
 *   （首页 hero 自带 lg:pt-20 + py-24 已避让，无需 offset）。
 * - ICP/公安备案信息已并入 Footer 底栏（renderCopyright 移植过去）。
 */
const Layout: SFC = ({children}) => {
  const {hash, pathname} = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [hash, pathname]);

  const isHome = pathname === ROUTES.home;

  return (
    <S.Layout data-testid="Layout">
      <S.LayoutTopNav />
      <S.LayoutContent className={isHome ? undefined : 'v3-page-offset'} data-testid="Layout__content">
        {children}
      </S.LayoutContent>
      <GoToTop />
      <Footer />
    </S.Layout>
  );
};

export default Layout;
